import { render, staticRenderFns } from "./CharacterCount.vue?vue&type=template&id=ff37f2b4&scoped=true&"
import script from "./CharacterCount.vue?vue&type=script&lang=js&"
export * from "./CharacterCount.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCount.vue?vue&type=style&index=0&id=ff37f2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff37f2b4",
  null
  
)

export default component.exports